import FieldsetTitle from '@/components/atoms/Fieldset/FieldsetTitle';
import IntegrationStatusBadge from '@/components/pages/Integrations/IntegrationStatus';
import { Card, CardContent } from '@/components/ui/card';
import { IntegrationStatus } from '@/shared/types/integration';

interface CardBaseHeaderProps {
  title: string;
  titleVariant?: 'primary' | 'secondary';
  status?: IntegrationStatus;
  active?: boolean;
}

interface CardBaseProps extends CardBaseHeaderProps {
  children: React.ReactNode;
}

export const CardBaseHeader = ({
  title,
  titleVariant = 'primary',
  status,
  active = true,
}: CardBaseHeaderProps) => (
  <div className="mb-2 flex items-center justify-between">
    <FieldsetTitle variant={titleVariant}>{title}</FieldsetTitle>
    {status && (
      <div className="mr-1.5 [&_span]:text-sm [&_span]:font-medium [&_span]:text-foreground-muted">
        <IntegrationStatusBadge integration={{ status, active }} />
      </div>
    )}
  </div>
);

export default function CardBase({ children, ...header }: CardBaseProps) {
  return (
    <div className="w-full">
      <CardBaseHeader {...header} />
      <Card className="rounded-lg border-stroke bg-background pb-7 shadow-none">
        <CardContent className="flex flex-col gap-6">{children}</CardContent>
      </Card>
    </div>
  );
}
